import { lazy } from 'react';
/** Открывает список городов */
export const CitiesPageAsync = lazy(() => import('./Cities/CitiesPage'));